import type { CSSProperties, ReactNode } from 'react'
import { ActionIcon, Box, Tooltip, type ActionIconProps, type TooltipProps } from '@mantine/core'

const TooltipIconButton = ({
  label,
  children,
  onClick,
  disabled,
  variant = 'default',
  size = 'lg',
  position,
  style,
}: {
  label: string
  children: ReactNode
  onClick: () => void
  disabled?: boolean
  variant?: ActionIconProps['variant']
  size?: ActionIconProps['size']
  position?: TooltipProps['position']
  style?: CSSProperties
}) => (
  <Tooltip label={label} withArrow position={position}>
    <Box component="span" style={{ display: 'inline-flex', ...style }}>
      <ActionIcon variant={variant} size={size} aria-label={label} disabled={disabled} onClick={onClick}>
        {children}
      </ActionIcon>
    </Box>
  </Tooltip>
)

export default TooltipIconButton
